import React from 'react'

import SeoHeader from '../components/SeoHeader'

export default function privacy() {
  return (
    <React.Fragment>
      <SeoHeader
        title='Privacy Policy'
      />
      <div className="px-10 text-justify mb-8 md:w-2/3 md:mx-auto md:mt-8">
        <h1 className="text-medium text-3xl mb-4">Privacy Policy</h1>
        <ol className="list-decimal">
          <li>
            The Intellectual Property disclosure will inform users that the contents, logo and other visual media you created is your property and is protected by copyright laws.
          </li>
          <li>
            A Termination clause will inform that users’ accounts on your website and mobile app or users’ access to your website and mobile (if users can’t have an account with you) can be terminated in case of abuses or at your sole discretion.
          </li>
          <li>
            A Governing Law will inform users which laws govern the agreement. This should the country in which your company is headquartered or the country from which you operate your website and mobile app.
          </li>
          <li>
            A Links To Other Web Sites clause will inform users that you are not responsible for any third party websites that you link to. This kind of clause will generally inform users that they are responsible for reading and agreeing (or disagreeing) with the Terms and Conditions or Privacy Policies of these third parties.
          </li>
          <li>
            If your website or mobile app allows users to create content and make that content public to other users, a Content section will inform users that they own the rights to the content they have created.
            <br className="mb-2" />
            The “Content” clause usually mentions that users must give you (the website or mobile app developer) a license so that you can share this content on your website/mobile app and to make it available to other users.
            <br className="mb-2" />
            Because the content created by users is public to other users, a DMCA notice clause (or Copyright Infringement ) section is helpful to inform users and copyright authors that, if any content is found to be a copyright infringement, you will respond to any DMCA takedown notices received and you will take down the content.
          </li>
          <li>
            A Limit What Users Can Do clause can inform users that by agreeing to use your service, they’re also agreeing to not do certain things. This can be part of a very long and thorough list in your Terms and Conditions agreements so as to encompass the most amount of negative uses.
          </li>
        </ol>
      </div>
    </React.Fragment>
  )
}
